import Axios from 'axios'
import * as dev from "@/utils/debugger";

const ApiServer = process.env.VUE_APP_API_SERVER || "https://xstudi-api.western.ac.th"

const axios = Axios.create({
  baseURL: ApiServer,
  headers: {}
  // Headers
})

export const graphqlClient = async (request = null) => {
  dev.log({ title: `API Request: ${request.name}`, request });
  if (request) {
    const res = await axios({
      url: "/graphql",
      method: "post",
      data: request.ql
    });

    let data;
    dev.log({ title: `API Response: ${request.name} =>`, res });

    if (request.name || request.name !== "") {
      data = res.data.data[request.name];
    } else {
      data = res.data.data;
    }

    return data;
  }
  return null;
}

export default {
  graphqlClient
};
